import { IntegrationTypeV3 } from '@vy/integrations-types';
import { useMutation, UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../../services/api';

type ModifyExternalProductRequest = {
  productId: string;
  integration: Exclude<IntegrationTypeV3, 'Connact'>;
  externalId: string | undefined;
};

export function useModifyExternalProduct(
  productId: string,
  options?: UseMutationOptions<void, unknown, ModifyExternalProductRequest>,
) {
  return useMutation({
    mutationKey: ['modifyExternalProduct', productId],
    mutationFn: async (modifyExternalProductRequest: ModifyExternalProductRequest) => {
      const api = getPrivateApi();

      return api.modifyExternalProduct(modifyExternalProductRequest);
    },
    ...options,
  });
}
